import * as ActionTypes from '../constants/ActionTypes';

export function onFieldChange(fieldName, fieldValue) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.UPDATE_DRAWER_FIELD,
			payload: {
				fieldName,
				fieldValue
			}
		});
	};
}